import { Dialog } from '@headlessui/react';
import React from 'react';
import { StatusDrawerSection } from './sections/status/StatusDrawerSection';
import { LocationDrawerSection } from './sections/location/LocationDrawerSection';
import { ListPriceDrawerSection } from './sections/listPrice/ListPriceDrawerSection';
import { BedsBathDrawerSection } from './sections/bedsBaths/BedsBathsDrawerSection';
import { HomeTypeDrawerSection } from './sections/homeType/HomeTypeDrawerSection';
import { PropertyDetailsDrawerSection } from './sections/propertyDetails/PropertyDetailsDrawerSection';
import { CostFinanceDrawerSection } from './sections/costFinance/CostFinanceDrawerSection';
import { useFilterController } from '../../application/useFilterController';
import { ListingDetailsDrawerSection } from './sections/listingDetails/ListingDetailsDrawerSection';

interface FilterOverlayDrawerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function FilterOverlayDrawer({
  open,
  setOpen,
}: FilterOverlayDrawerProps) {
  const { resetFilter } = useFilterController();

  return (
    <Dialog open={open} onClose={setOpen} className="relative z-50">
      {/* Background overlay - clickable to close */}
      <div
        className="fixed inset-0 bg-black bg-opacity-25"
        onClick={() => setOpen(false)}
      />

      {/* Drawer panel */}
      <div className="fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
        <Dialog.Panel className="w-screen max-w-full sm:max-w-lg md:max-w-xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700">
          <div
            id="filter-overlay-drawer-content-container"
            className="relative flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl dark:divide-white/10 dark:bg-gray-800 dark:after:absolute dark:after:inset-y-0 dark:after:left-0 dark:after:w-px dark:after:bg-white/10 overflow-x-hidden"
          >
            {/* content */}
            <div
              id="filter-overlay-drawer-content"
              className="flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden"
            >
              <div
                id="filter-overlay-drawer-content-body"
                className="relative flex-1 px-2 sm:px-4 overflow-x-hidden [&>*+*]:border-t [&>*+*]:border-gray-200 [&>*+*]:sm:pt-6 [&>*+*]:mt-4 dark:[&>*+*]:border-white/10"
              >
                <StatusDrawerSection />
                <LocationDrawerSection />
                <ListPriceDrawerSection />
                <BedsBathDrawerSection />
                <HomeTypeDrawerSection />
                <PropertyDetailsDrawerSection />
                <CostFinanceDrawerSection />
                <ListingDetailsDrawerSection />
              </div>
            </div>
            {/* footer */}
            <div
              id="filter-overlay-drawer-footer"
              className="flex shrink-0 justify-between px-4 py-4 border-1 border-gray-200"
            >
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 dark:hover:ring-white/5"
              >
                Close
              </button>
              <button
                type="reset"
                onClick={resetFilter}
                className="inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
              >
                Reset
              </button>
              {/* <button
                type="submit"
                className="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
              >
                Save
              </button> */}
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
